import request from '@/utils/request'

/**
 * 查询服务评价列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryShopAppraise(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopAppraise/queryShopAppraise',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}